import React, { useState } from 'react';
import './ProductosPage.css';
import Header from './Header';
import AnimatedBackground from './AnimatedBackground';

const ProductosPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Todos', icon: 'fas fa-th' },
    { id: 'artesanales', name: 'Artesanales', icon: 'fas fa-palette' },
    { id: 'bienestar', name: 'Bienestar', icon: 'fas fa-leaf' },
    { id: 'aceites', name: 'Aceites', icon: 'fas fa-tint' },
    { id: 'accesorios', name: 'Accesorios', icon: 'fas fa-gem' }
  ];

  const products = [
    {
      id: 1,
      name: 'Aceite de Lavanda',
      category: 'aceites',
      price: 45000,
      image: '/images/aceite-lavanda.jpg',
      description: 'Aceite esencial de lavanda para relajación y bienestar',
      tags: ['relajante', 'natural', 'aromaterapia']
    },
    {
      id: 2,
      name: 'Joyería Artesanal',
      category: 'artesanales',
      price: 120000,
      image: '/images/joyeria-artesanal.jpg',
      description: 'Piezas únicas de joyería hechas a mano',
      tags: ['artesanal', 'único', 'hecho a mano']
    },
    {
      id: 3,
      name: 'Mat de Yoga',
      category: 'accesorios',
      price: 85000,
      image: '/images/mat-yoga.jpg',
      description: 'Mat de yoga ecológico para tu práctica',
      tags: ['ecológico', 'yoga', 'bienestar']
    },
    {
      id: 4,
      name: 'Aceite de Eucalipto',
      category: 'aceites',
      price: 42000,
      image: '/images/aceite-eucalipto.jpg',
      description: 'Aceite esencial de eucalipto para respirar mejor',
      tags: ['respiratorio', 'natural', 'fresco']
    },
    {
      id: 5,
      name: 'Cerámica Artesanal',
      category: 'artesanales',
      price: 95000,
      image: '/images/ceramica-artesanal.jpg',
      description: 'Piezas de cerámica únicas para el hogar',
      tags: ['artesanal', 'hogar', 'decorativo']
    },
    {
      id: 6,
      name: 'Suplemento Natural',
      category: 'bienestar',
      price: 65000,
      image: '/images/suplemento-natural.jpg',
      description: 'Suplemento natural para el bienestar integral',
      tags: ['natural', 'bienestar', 'salud']
    }
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  return (
    <div className="productos-page">
      <Header />
      <main className="productos-main">
        <AnimatedBackground particleCount={6} staticCount={2} />
        
        {/* Hero Section */}
        <section className="productos-hero">
          <div className="container">
            <h1 className="hero-title">Nuestros Productos</h1>
            <p className="hero-subtitle">
              Descubre nuestra selección cuidadosa de productos artesanales únicos y productos para el bienestar
            </p>
          </div>
        </section>

        {/* Categories */}
        <section className="categories-section">
          <div className="container">
            <div className="categories-grid">
              {categories.map(category => (
                <button
                  key={category.id}
                  className={`category-card ${selectedCategory === category.id ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category.id)}
                >
                  <i className={category.icon}></i>
                  <span>{category.name}</span>
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Products Grid */}
        <section className="products-section">
          <div className="container">
            <div className="products-grid">
              {filteredProducts.map(product => (
                <div key={product.id} className="product-card">
                  <div className="product-image">
                    <img src={product.image} alt={product.name} />
                    <div className="product-overlay">
                      <button className="add-to-cart-btn">
                        <i className="fas fa-shopping-cart"></i>
                        Agregar al Carrito
                      </button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h3 className="product-name">{product.name}</h3>
                    <p className="product-description">{product.description}</p>
                    <div className="product-tags">
                      {product.tags.map((tag, index) => (
                        <span key={index} className="product-tag">{tag}</span>
                      ))}
                    </div>
                    <div className="product-price">
                      <span className="price">${product.price.toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <h2>¿No encuentras lo que buscas?</h2>
            <p>Contáctanos y te ayudaremos a encontrar el producto perfecto para ti</p>
            <button className="btn btn-primary">Contactar</button>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ProductosPage;
